export function useMeta() {
    function getTextExcerptFromHTML(html = '', maxLength = 500) {
        // Step 1: Strip HTML
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = html
        const text = tempDiv.textContent || ''

        if (text.length <= maxLength) return text.trim()

        // Step 2: Truncate to maxLength
        const truncated = text.slice(0, maxLength)

        // Step 3: Find last full sentence (ending with a period)
        const lastPeriodIndex = truncated.lastIndexOf('.')

        if (lastPeriodIndex > 0) {
            return truncated.slice(0, lastPeriodIndex + 1).trim()
        }

        // If no period found, fallback to nearest word boundary
        const lastSpaceIndex = truncated.lastIndexOf(' ')

        return (lastSpaceIndex > 0 ? truncated.slice(0, lastSpaceIndex) : truncated).trim() + '...'
    }

    function extractAuthorsFromHTML(html = '') {
        if (!html || typeof html !== 'string') {
            return [];
        }

        const affiliationIndicators = [
            // English
            'university', 'institute', 'department', 'service', 'faculty',
            'clinic', 'hospital', 'center', 'centre', 'central', 'cardiac',
            'cardiolog', 'school', 'division', 'medical', 'medicine',
            'research', 'science', 'scientific', 'register', 'college',
            'internal', 'group',

            // Hungarian
            'egyetem', 'intézet', 'részleg', 'osztály', 'szolgálat',
            'klinika', 'kórház', 'központ', 'centrum', 'tanszék',
            'kardiológ', 'iskola', 'tudomány', 'általános', 'sebészet',
            'gyógyászat', 'regiszter', 'kft.', 'csoport', 'fejlesztés',
            'betegség',

            // Special
            'e-mail', ':', '@'
        ];

        /*
         * Parse the HTML using the browser's HTML parser.
         *
         * This also automatically decodes entities such as:
         *   &sup; -> ⊃
         */
        const container = document.createElement('div');
        container.innerHTML = html;

        /*
         * Remove actual <sup> elements.
         */
        container.querySelectorAll('sup').forEach(sup => sup.remove());

        /*
         * Convert <br> elements to newlines before extracting text.
         */
        container.querySelectorAll('br').forEach(br => {
            br.replaceWith('\n');
        });

        /*
         * textContent gives us decoded text, so HTML entities are
         * converted to their actual characters.
         */
        let text = container.textContent || '';

        /*
         * Remove Unicode superscript digits:
         *
         * ⁰¹²³⁴⁵⁶⁷⁸⁹
         *
         * Also remove common superscript/marker characters that can
         * appear when WYSIWYG/editor output is inconsistent.
         *
         */
        text = text
            .replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹]/g, '')
            .replace(/\u2283/g, '') // ⊃
            .replace(/\u207A/g, '') // ⁺
            .replace(/\u207B/g, '') // ⁻
            .replace(/\u207D/g, '') // ⁽
            .replace(/\u207E/g, '') // ⁾
            .replace(/\*/g, '');

        /*
         * Normalize whitespace while preserving line breaks.
         */
        text = text
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .replace(/[ \t]+/g, ' ')
            .replace(/[ \t]*\n[ \t]*/g, '\n')
            .trim();

        /*
         * Split into logical lines.
         */
        const lines = text
            .split('\n')
            .map(line => line.trim())
            .filter(Boolean);

        let authorsText = '';

        /*
         * The first line(s) are assumed to contain the authors.
         * Stop when an affiliation indicator is encountered.
         */
        for (const line of lines) {
            const lower = line.toLowerCase();

            if (affiliationIndicators.some(word => lower.includes(word))) {
                break;
            }

            authorsText += (authorsText ? ', ' : '') + line;
        }

        /*
         * Split authors by comma.
         */
        return authorsText
            .split(',')
            .map(name => name.trim())
            .filter(Boolean);
    }

    function formatTimestamp(timestamp, separator = '-') {
        const date = new Date(timestamp)

        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}${separator}${month}${separator}${day}`
    }

    return { getTextExcerptFromHTML, extractAuthorsFromHTML, formatTimestamp }
}
